import get from 'lodash.get';

export const selectApGroups = state => get(state, 'models.apGroups.data');
export const selectDefaultApGroup = state => {
  return selectApGroups(state).find(({ attr_hidden_id }) => attr_hidden_id === 'default');
};
export const selectDefaultApGroupId = state => {
  return get(selectDefaultApGroup(state), '_id');
};
